
import Vue from 'vue'
import { mapGetters } from 'vuex'

import GardenCard from '@/ui/components/gardens/GardenCard.vue'
import LogTimeline from '@/ui/components/timeline/LogTimeline.vue'

export default Vue.extend({
  name: 'HelloWorld',

  components: {
    GardenCard,
    LogTimeline,
  },
  data: () => ({
    // selectedPlantIds: [],
  }),
  computed: {
    ...mapGetters({
      gardens: 'gardens',
      // plants: 'plants',
      // harvests: 'harvests',
      // logItems: 'log/log',
    }),
  },
  // watch: {
  //   plants(newVal, oldVal) {
  //     console.log(oldVal)
  //     console.log(newVal)

  //     // console.log(newVal.harvests())
  //   },
  // },
  methods: {
    // print(stuff: any) {
    //   console.log(stuff)
    // },
  },
})
